import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ProfileCard,
  type ProfileCardContract,
  type ProfileSurface,
} from '../../../../app/_shared/educationProfile';
import type {
  StudentProfileStepId,
  StudentProfileStepProgress,
} from '../../application/studentProfileSteps';
import { StudentProfileSteps } from './StudentProfileSteps';

type StudentProfileSummaryProps = {
  surface: Extract<ProfileSurface, 'edit' | 'pre-edit'>;
  displayName: string;
  timezoneLabel: string;
  percent: number;
  steps: StudentProfileStepProgress[];
  activeStepId: StudentProfileStepId;
  onStepSelect: (id: StudentProfileStepId) => void;
  onContinue: () => void;
  picture: ReactNode;
};

export function StudentProfileSummary({
  surface,
  displayName,
  timezoneLabel,
  percent,
  steps,
  activeStepId,
  onStepSelect,
  onContinue,
  picture,
}: StudentProfileSummaryProps) {
  const { t } = useTranslation();
  const isComplete = percent >= 100;
  const contract: ProfileCardContract = {
    surface,
    identity: {
      displayName,
      timezoneLabel,
      title: t('dashboard.profileCard.student_title'),
      picture,
    },
    progress: {
      percent,
      hint: isComplete ? null : t('dashboard.profileCard.student_hint'),
      cta: {
        label: isComplete
          ? t('dashboard.profileCard.cta_edit')
          : t('student-profile.continue'),
        primary: !isComplete,
        onClick: onContinue,
      },
    },
  };

  return (
    <>
      <ProfileCard contract={contract} />
      <StudentProfileSteps
        steps={steps}
        activeStepId={activeStepId}
        onStepSelect={onStepSelect}
      />
    </>
  );
}
